import { createPinia } from 'pinia';

const store = createPinia();
export * from './modules/auth.store';
export * from './modules/utils.store';
export * from './modules/reg.store';
export * from './modules/forgotpass.store';
export * from './modules/account.store';
export * from './modules/verify.store';
export { store };